// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1kAwB","text":"SelectPayment_text__2oNY4","title":"SelectPayment_title__1kbj1","btn":"SelectPayment_btn__1Iy4J"};